<template>
  <div>
    <div class="content-box">
      <div class="row">
        <div class="col-lg-12">
          <div class="element-wrapper">
            <div class="element-box">
              <form @submit="guardar">
                <h5 class="form-header">Nueva Serie para Cargo</h5>
                <div class="form-desc">Adición de una nueva serie para cargo</div>
                <div class="row">
                  <div class="col-sm-3 col-md-2">
                    <div class="form-group">
                      <label
                        v-bind:class="{ 'text-danger': current.errors.serie && current.errors.serie.length > 0 }"
                      >serie</label>
                      <input
                        v-model="current.serie"
                        autofocus="autofocus"
                        class="form-control"
                        placeholder="Serie"
                        type="text"
                        v-bind:class="{ 'is-invalid': current.errors.serie && current.errors.serie.length > 0 }"
                      >
                      <small
                        v-if="current.errors && current.errors.serie"
                        class="form-text text-danger"
                      >{{ current.errors.serie[0] }}</small>
                    </div>
                  </div>
                  <div class="col-sm-9 col-md-3">
                    <div class="form-group">
                      <label
                        v-bind:class="{ 'text-danger': current.errors.no_resolucion && current.errors.no_resolucion.length > 0 }"
                      >Numero Resolucion</label>
                      <input
                        v-model="current.no_resolucion"
                        class="form-control"
                        placeholder="No. Resolución"
                        v-bind:class="{ 'is-invalid': current.errors.no_resolucion && current.errors.no_resolucion.length > 0 }"
                        type="text"
                      >
                      <small
                        v-if="current.errors && current.errors.no_resolucion"
                        class="form-text text-danger"
                      >{{ current.errors.no_resolucion[0] }}</small>
                    </div>
                  </div>
                  <div class="col-sm-9 col-md-3">
                    <div class="form-group">
                      <label
                        v-bind:class="{ 'text-danger': current.errors.correlativo_inicial && current.errors.correlativo_inicial.length > 0 }"
                      >Correlativo Inicial</label>
                      <input
                        v-model="current.correlativo_inicial"
                        class="form-control"
                        placeholder="Ultimo Correlativo Inicial"
                        v-bind:class="{ 'is-invalid': current.errors.correlativo_inicial && current.errors.ultimo_impreso.length > 0 }"
                        type="text"
                      >
                      <small
                        v-if="current.errors && current.errors.correlativo_inicial"
                        class="form-text text-danger"
                      >{{ current.errors.correlativo_inicial[0] }}</small>
                    </div>
                  </div>
                  <div class="col-sm-9 col-md-3">
                    <div class="form-group">
                      <label
                        v-bind:class="{ 'text-danger': current.errors.correlativo_final && current.errors.correlativo_final.length > 0 }"
                      >Correlativo Final</label>
                      <input
                        v-model="current.correlativo_final"
                        class="form-control"
                        placeholder="Correlativo Final"
                        v-bind:class="{ 'is-invalid': current.errors.correlativo_final && current.errors.correlativo_final.length > 0 }"
                        type="text"
                      >
                      <small
                        v-if="current.errors && current.errors.correlativo_final"
                        class="form-text text-danger"
                      >{{ current.errors.correlativo_final[0] }}</small>
                    </div>
                  </div>
                  <div class="col-sm-9 col-md-3">
                    <div class="form-group">
                      <label
                        v-bind:class="{ 'text-danger': current.errors.fecha_resolucion && current.errors.fecha_resolucion.length > 0 }"
                      >Fecha Resolución</label>
                      <input
                        v-model="current.fecha_resolucion"
                        class="form-control"
                        v-bind:class="{ 'is-invalid': current.errors.fecha_resolucion && current.errors.fecha_resolucion.length > 0 }"
                        type="date">
                      <small
                        v-if="current.errors && current.errors.fecha_resolucion"
                        class="form-text text-danger"
                      >{{ current.errors.fecha_resolucion[0] }}</small>
                    </div>
                  </div>
                  <div class="col-sm-9 col-md-3">
                    <div class="form-group">
                      <label
                        v-bind:class="{ 'text-danger': current.errors.fecha_resolucion_vence && current.errors.fecha_resolucion_vence.length > 0 }"
                      >Fecha Resolución Vence</label>
                      <input
                        v-model="current.fecha_resolucion_vence"
                        class="form-control"
                        v-bind:class="{ 'is-invalid': current.errors.fecha_resolucion_vence && current.errors.fecha_resolucion_vence.length > 0 }"
                        type="date"
                      >
                      <small
                        v-if="current.errors && current.errors.fecha_resolucion_vence"
                        class="form-text text-danger"
                      >{{ current.errors.fecha_resolucion_vence[0] }}</small>
                    </div>
                  </div>
                  <div class="col-sm-12 col-md-3">
                      <div class="form-group">
                        <label
                          v-bind:class="{ 'text-danger': current.errors.tienda && current.errors.tienda.length > 0 }"
                        >Tienda</label>
                        <select
                          class="form-control"
                          autofocus="autofocus"
                          v-model="current.tienda"
                          @change="refreshTienda"
                          @input="$emit('input', $event.target.value)"
                        >
                          <option
                            v-for="(c, key) in tiendas"
                            :value="c.codigo"
                            :key="key"
                          >{{ c.nombre }}</option>
                        </select>
                        <small
                          v-if="current.errors && current.errors.tienda"
                          class="form-text text-danger"
                        >{{ current.errors.tienda[0] }}</small>
                      </div>
                    </div>
                    <div class="col-sm-12 col-md-3">
                      <div class="form-group">
                        <label
                          v-bind:class="{ 'text-danger': current.errors.tienda && current.errors.tienda.length > 0 }"
                        >Tipo Cargo</label>
                        <select
                          class="form-control"
                          autofocus="autofocus"
                          v-model="current.cxc_tipo_cargo"
                          @change="refreshAbono"
                          @input="$emit('input', $event.target.value)"
                        >
                          <option
                            v-for="(c, key) in cargos"
                            :value="c.id"
                            :key="key"
                          >{{ c.nombre }}</option>
                        </select>
                        <small
                          v-if="current.errors && current.errors.tienda"
                          class="form-text text-danger"
                        >{{ current.errors.tienda[0] }}</small>
                      </div>
                    </div>
                </div>
                <div class="form-buttons-w">
                  <button class="btn btn-primary" type="submit">Guardar</button>
                  <router-link class="btn btn-default" :to="{ name: 'cxc-cargo-serie', params: {  }}">
                    <i class="fa fa-back"></i>
                    Volver al Listado
                    
                  </router-link>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import _ from "lodash";
import { mapGetters } from "vuex";
import CargoSerieService from "@/services/cxc/CargoSerieService";
import Notifications from "@/notifications/notifications";


export default {
  data() {
    return {
      current: {
        errors: {}
      }
    };
  },
  computed: {
    ...mapGetters({
      tiendas: "catalogos/tiendas",
      cargos: "cargos/tipocargo"
    }),
  },
  mounted() {
    if (this.$route.params.id) {
      CargoSerieService.getById(this.$route.params.id).then(response => {
        this.current = response.data;
        this.current.errors = [];
        this.current.id;
        this.refreshTienda();
    });
}
  this.refreshTienda();
  this.refreshAbono();
},
  methods: {
    refreshTienda() {
      let self = this;
      self.$store.dispatch("catalogos/tiendas", {
        activa: true,
        tienda: self.current.tienda,
        quitar_paginacion: true
      });
    },
    refreshAbono() {
      let self = this;
      self.$store.dispatch("cargos/tipocargo", {
        activa: true,
        cargo: self.current.cxc_tipo_cargo,
        quitar_paginacion: true
      });
    },
guardar(e) {
      let self = this;
      e.preventDefault();
      var current = Object.assign({}, self.current);
      delete current.image;
      if (this.$route.params.id) {
        current.pk = this.$route.params.id;
        delete current.id;
      }
      console.info(current);
      CargoSerieService.save(current)
        .then(res => {
          self.current = res.data;
          self.current.id;
          self.current.errors = {};
          Notifications.alert.success(
            "Serie Cargo",
            "Se ha guardado la Información."
          );
          self.$router.push({
            name: "cxc-cargo-serie",
            params: { id: self.current.id }
          });
        })
        .catch(error => {
          Vue.nextTick(function() {
            self.current.errors = Object.assign({}, error.response.data);
            console.log(self.current.errors);
          });
        });
    },
    showModal(e) {
      e.preventDefault();
    }
  }
};
</script>
